import Column from '@components/Column';
import Image from '@components/Image';
import ImageIndicator from '@components/ImageIndicator';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { ShopResponse } from '@models/shop';
import { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Swiper, SwiperClass, SwiperSlide } from 'swiper/react';

interface Props {
    shop?: ShopResponse;
}

function ShopImages({ shop }:Props) {
    const imageExists = (shop?.images.length || 0) !== 0;
    const swiperRef = useRef<SwiperClass|null>(null);
    const [index, setIndex] = useState<number>(0);
    const { t } = useTranslation('shopDetail');

    if (imageExists) {
        return (
            <Column fullWidth align='center'>
                <Swiper loop
                    slidesPerView={1}
                    onSwiper={(s) => {
                        swiperRef.current = s;
                    }}
                    onSlideChange={(swiper) => {
                        setIndex(swiper.realIndex);
                    }}
                    css={css`width: 100%;`} >
                    {shop?.images.map((img, j) => (
                        <SwiperSlide key={j.toString()}>
                            <ShopImage src={img}
                                width={720}
                                height={480}
                                alt={`${t('imageAlt')} ${j}`} />
                        </SwiperSlide>
                    ))}
                </Swiper>
                <ImageIndicator size={shop?.images.length}
                    current={index}
                    slickNext={() => swiperRef?.current?.slideNext()}
                    slickPrev={() => swiperRef.current?.slidePrev()} />
            </Column>
        );
    }

    return null;
}

const ShopImage = styled(Image)`
    aspect-ratio: calc(360 / 218);
    height: auto;
    width: 100%;
    object-fit: cover;
`;

export default ShopImages;
